module.exports = __webpack_public_path__ + "img/00020.9b66adb2.webp";